module.exports = __webpack_public_path__ + "static/media/1.8846a5fb.jpg";